/**
 * Maps design tokens to Ant Design v5 theme.
 * Keep hex values aligned with src/design-system/tokens.css
 */
export const hrAntdTheme = {
  token: {
    colorPrimary: "#fe3702",
    colorSuccess: "#25ac03",
    colorWarning: "#e6a700",
    colorError: "#c62828",
    colorInfo: "#0258a4",
    colorTextBase: "#0d0d0d",
    colorBgContainer: "#ffffff",
    colorBgLayout: "#fafafa",
    colorBorder: "#e8e8e8",
    colorBorderSecondary: "#f3f3f3",
    borderRadius: 10,
    borderRadiusLG: 14,
    borderRadiusSM: 6,
    fontFamily: `"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`,
    fontSize: 15,
    fontSizeLG: 16,
    fontSizeSM: 13,
    controlHeight: 40,
    controlHeightLG: 44,
    controlHeightSM: 32,
    paddingContentHorizontal: 16,
    paddingContentVertical: 12,
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
    boxShadowSecondary: "0 4px 12px rgba(15, 23, 42, 0.08)",
    zIndexPopupBase: 1000,
  },
  components: {
    Button: {
      primaryShadow: "0 1px 3px rgba(254, 55, 2, 0.2)",
      defaultShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
      fontWeight: 600,
      contentFontSize: 14,
      paddingInline: 16,
    },
    Input: {
      activeBorderColor: "#0258a4",
      hoverBorderColor: "#d0d0d0",
      hoverBg: "#ffffff",
      borderRadius: 10,
      paddingBlock: 7,
      paddingInline: 14,
      inputFontSize: 15,
      colorTextPlaceholder: "#757575",
      activeShadow: "0 0 0 3px rgba(2, 88, 164, 0.25)",
    },
    Select: {
      borderRadius: 10,
      optionHeight: 40,
      optionFontSize: 15,
      optionLineHeight: 1.45,
      colorTextPlaceholder: "#757575",
    },
    DatePicker: {
      activeBorderColor: "#0258a4",
      hoverBorderColor: "#d0d0d0",
      borderRadius: 10,
      cellHeight: 32,
    },
    InputNumber: {
      activeBorderColor: "#0258a4",
      hoverBorderColor: "#d0d0d0",
      borderRadius: 10,
    },
    AutoComplete: {
      borderRadius: 10,
    },
    Card: {
      borderRadiusLG: 14,
      paddingLG: 20,
    },
    Modal: {
      borderRadiusLG: 14,
    },
    Drawer: {
      borderRadiusLG: 14,
    },
    Table: {
      borderRadius: 10,
      headerBg: "#fafafa",
    },
  },
};
